<template>
  <main >
    <home-hero></home-hero>
    
    <home-why id="home-why"></home-why>
    <home-education id="home-education"></home-education>
    <home-data id="home-data"></home-data>
    <home-contest id="home-contest"></home-contest>
    <home-testimonials id="home-testimonials"></home-testimonials>
  </main>
</template>

<script>
import HomeHero from "../components/home/HomeHero.vue";

import HomeWhy from "../components/home/HomeWhy.vue";
import HomeEducation from "../components/home/HomeEducation.vue";
import HomeData from "../components/home/HomeData.vue";
import HomeContest from '../components/home/HomeContest.vue';
import HomeTestimonials from "../components/home/HomeTestimonials.vue";


export default {
  components: {
    "home-hero": HomeHero,
    "home-why": HomeWhy,
    "home-education": HomeEducation,
    "home-data": HomeData,
    "home-contest": HomeContest,
    "home-testimonials": HomeTestimonials,
    
  },
  head() {
    return {
      title: "INVRS - Start your investment journey!",
      meta:[
        { 
          name: "description",
          content: 'Improve your financial future with INVRS. Master finance and investing concepts, with access to tools and courses on a comprehensive eLearning platform.'
        },
         { 
          name: "twitter:title",
          content: 'INVRS - Start your investment journey!'
        },
        { 
          name: "twitter:description",
          content: 'Improve your financial future with INVRS. Master finance and investing concepts, with access to tools and courses on a comprehensive eLearning platform.'
        },
         { 
          name: "og:title",
          content: 'INVRS - Start your investment journey!'
        },
        { 
          name: "og:description",
          content: 'Improve your financial future with INVRS. Master finance and investing concepts, with access to tools and courses on a comprehensive eLearning platform.'
        },
      ]
    }
  }
 
};
</script>

